import { Injectable, Type } from '@angular/core';

import { IAzavistaAvailableWidgetsItem } from '@azavista/components/dashboard';
import { IWidgetComponentDefinition, AbstractWidgetDirective } from '@azavista/components/widgets';
import { TranslationKey, ReportType } from '../enums';
import { WidgetDefinitionDataType, WidgetDefinitionType } from './interfaces';
import { SharedService } from '../shared.service';
import { EventsByTypeWidgetComponent } from './events-by-type/events-by-type-widget.component';
import { ParticipantsByTypeWidgetComponent } from './participants-by-type/participants-by-type-widget.component';
import { CountdownClockWidgetComponent } from './countdown-clock/countdown-clock-widget.component';
import { ParticipantsByStageWidgetComponent } from './participants-by-stage/participants-by-stage-widget.component';
import { ObjectCountWidgetComponent } from './object-count/object-count-widget.component';
import { IconName } from '../icons-enum';
import { EventWaitingListWidgetComponent } from './event-waiting-list/event-waiting-list-widget.component';
import { ActivityParticipantGroupByStatusWidgetComponent } from './activity-participant-group-by-status/activity-participant-group-by-status-widget.component';
import { SalesByProductWidgetComponent } from './sales-by-product/sales-by-product-widget.component';
import { EmailCampaignDeliveryWidgetComponent } from './email-campaign-delivery/email-campaign-delivery.component';
import { TranslationMapKey } from '../const';
import { SalesByProductQuantityWidgetComponent } from './sales-by-product-quantity/sales-by-product-quantity.component';

@Injectable({
    providedIn: 'root'
})
export class WidgetsSharedService {
    constructor(private sharedSvc: SharedService) {
    }

    // adjustHeight(chartType: ChartType, chartWidth: number, desiredHeight: number): number {
    //     // Setting height is a little bit more complicated
    //     // On square type of charts (donut), available height should not be more than the width
    //     let newHeight: number;
    //     if (chartType === 'donut') {
    //         newHeight = (chartWidth && desiredHeight > chartWidth) ? chartWidth : desiredHeight;
    //         const minDiff = 80;
    //         if (chartWidth && (chartWidth - newHeight) < minDiff) {
    //             newHeight = chartWidth - minDiff;
    //         }
    //     } else {
    //         newHeight = desiredHeight;
    //     }
    //     // The diff between width-height should not be less than 50
    //     return newHeight;
    // }

    createAvailableWidgetItem(
        titleTranslationKey: TranslationKey | TranslationMapKey,
        descriptionTranslationKey: TranslationKey | TranslationMapKey,
        exampleTranslationKey: TranslationKey | TranslationMapKey,
        definitionDataType: WidgetDefinitionDataType,
        reportType: ReportType,
        context: any
    ): IAzavistaAvailableWidgetsItem {
        const item: IAzavistaAvailableWidgetsItem = {
            title: this.sharedSvc.translate(titleTranslationKey),
            description: this.sharedSvc.translate(descriptionTranslationKey),
            example: exampleTranslationKey ? this.sharedSvc.translate(TranslationKey.example) + ': ' + this.sharedSvc.translate(exampleTranslationKey) : '',
            icon: IconName.bar_chart,
            selected: false,
            definition: {
                dataType: definitionDataType,
                type: WidgetDefinitionType.chart,
                title: this.sharedSvc.translate(titleTranslationKey),
                data: null,
                reportType: reportType,
                context: context
            } as IWidgetComponentDefinition
        };
        this.setAvailableWidgetComponent(item);
        return item;
    }

    private setAvailableWidgetComponent(item: IAzavistaAvailableWidgetsItem): void {
        item.definition.componentType = this.getComponentTypeFromWidget(
            item.definition.type, item.definition.dataType as WidgetDefinitionDataType
        );
    }

    getComponentTypeFromWidget(definitionType: string, definitionDataType: WidgetDefinitionDataType): Type<AbstractWidgetDirective> {
        if (definitionType === WidgetDefinitionType.chart) {
            if (definitionDataType === WidgetDefinitionDataType.eventsByEventType) {
                return EventsByTypeWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.participantsByEventType) {
                return ParticipantsByTypeWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.participantsByStage) {
                return ParticipantsByStageWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.countdownClock) {
                return CountdownClockWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.objectCount) {
                return ObjectCountWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.eventWaitingList) {
                return EventWaitingListWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.activityParticipantGroupByStatus) {
                return ActivityParticipantGroupByStatusWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.salesByProduct) {
                return SalesByProductWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.salesByProductQuantity) {
                return SalesByProductQuantityWidgetComponent;
            }
            if (definitionDataType === WidgetDefinitionDataType.emailCampaignDelivery) {
                return EmailCampaignDeliveryWidgetComponent;
            }
        }
        return null;
    }
}
